import type { ColorVariablesType } from '@/types/common.type'
import cls from 'classnames'
import { CSSProperties, ReactNode } from 'react'
import st from './styles.module.scss'

interface TextProps {
  size: string
  content: string | number | ReactNode
  fontWeight?: number
  color?: ColorVariablesType
  textTransform?: 'uppercase' | 'capitalize' | 'lowercase' | 'unset'
  fontStyle?: 'italic' | 'unset'
  customClassName?: string
  customStyle?: CSSProperties
  pointer?: boolean
  onClick?: () => void
  maxWidth?: number
  padding?: string | number
  isTextOverflow?: boolean
}

const Text = ({
  size,
  content,
  fontWeight = 400,
  color = '--black-85',
  textTransform = 'unset',
  fontStyle,
  customClassName,
  customStyle,
  pointer,
  onClick,
  maxWidth,
  padding,
  isTextOverflow
}: TextProps) => {
  return (
    <p
      className={cls(
        {
          text: true,
          [st[`text-${size}`]]: true,
          [st['text-overflow']]: isTextOverflow
        },
        customClassName
      )}
      onClick={onClick}
      style={{
        ...customStyle,
        userSelect: 'none',
        fontWeight: fontWeight,
        color: `var(${color})`,
        cursor: pointer ? 'pointer' : 'unset',
        textTransform,
        fontStyle,
        maxWidth,
        padding
      }}
    >
      {content}
    </p>
  )
}

export default Text
